// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Dm-z","badgeLink":"Em-z","category":"Fm-z"};